/* eslint-disable */
import { Jockey } from '@/models/jockey'

const JOCKEY_FIRST_NAMES = [
    'Alex', 'Sam', 'Jamie', 'Chris', 'Pat', 'Jordan', 'Taylor', 'Casey', 'Morgan',
    'Drew', 'Blake', 'Riley', 'Avery', 'Quinn', 'Skylar', 'Parker', 'Charlie',
    'John', 'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'William', 'Sophia', 'James',
    'Isabella', 'Oliver', 'Charlotte', 'Benjamin', 'Mia', 'Elijah', 'Luna', 'Lucas',
    'Esther', 'Olivia', 'Tifa', 'Palmer', 'Rufus', 'Bugen', 'Sam', 'Bruno',
    'Andrew', 'James', 'Ste', 'Stevie', 'Emma', 'Liam', 'Olivia', 'Noah', 'Ava', 'William', 'Sophia', 'James',
    'Isabella', 'Oliver', 'Charlotte', 'Benjamin', 'Mia', 'Elijah', 'Luna', 'Lucas',
    'Esther', 'Olivia', 'Tifa', 'Palmer', 'Rufus', 'Bugen', 'Sam',
    'John', 'Evelyn', 'Alexander', 'Harper', 'Jacob', 'Amelia', 'Michael', 'Emily',
    'Daniel', 'Abigail', 'Matthew', 'Elizabeth', 'Joshua', 'Avery', 'Christopher',
    'Sofia', 'Andrew', 'Ella', 'Joseph', 'Lily', 'William', 'Grace', 'David',
    'Zoey', 'Ryan', 'Victoria', 'Jacob', 'Aubrey', 'Alexander', 'Scarlett',
    'Ethan', 'Addison', 'Benjamin', 'Hannah', 'Lucas', 'Natalie', 'Michael',
    'Isabella', 'Alexander', 'Emma', 'Jacob', 'Olivia', 'William', 'Ava',
    'Daniel', 'Sophia', 'Ethan', 'Charlotte', 'Alexander', 'Mia', 'James',
    'Harper', 'Benjamin', 'Emily', 'Joseph', 'Abigail', 'Matthew', 'Elizabeth',
    'Andrew', 'Avery', 'Christopher', 'Ella', 'Joshua', 'Lily', 'David',
    'Zoey', 'Ryan', 'Victoria', 'Jacob', 'Aubrey', 'Alexander', 'Scarlett',
    'Ethan', 'Addison', 'Benjamin', 'Hannah', 'Lucas', 'Alan', 'Scott', 'Finlay',
    'Eoin', 'Kris', 'Nadia', 'Bobson', 'Swetha',
    // Additional names
    'Aaron', 'Abel', 'Abraham', 'Adam', 'Adrian', 'Aiden', 'Albert', 'Alec', 'Alfred', 'Alice',
    'Alicia', 'Allison', 'Amanda', 'Amber', 'Amy', 'Andrea', 'Angela', 'Angelica', 'Anita', 'Anna',
    'Anne', 'Annie', 'Anthony', 'Antonio', 'April', 'Archie', 'Arthur', 'Ashley', 'Austin', 'Barbara',
    'Barry', 'Beatrice', 'Bella', 'Bernard', 'Beth', 'Beverly', 'Bill', 'Billy', 'Bob', 'Bobby',
    'Bonnie', 'Brad', 'Bradley', 'Brandon', 'Brenda', 'Brendan', 'Brett', 'Brian', 'Brianna', 'Bridget',
    'Brittany', 'Bruce', 'Bryan', 'Byron', 'Caleb', 'Calvin', 'Cameron', 'Camila', 'Carl', 'Carla',
    'Carlos', 'Carmen', 'Carol', 'Caroline', 'Carolyn', 'Carrie', 'Carter', 'Catherine', 'Cathy', 'Cecil',
    'Cedric', 'Celeste', 'Chad', 'Chandler', 'Charles', 'Chelsea', 'Cheryl', 'Chester', 'Chloe', 'Christian',
    'Christina', 'Christine', 'Chuck', 'Cindy', 'Claire', 'Clara', 'Clarence', 'Clark', 'Claude', 'Claudia',
    'Clayton', 'Clifford', 'Clint', 'Clinton', 'Clyde', 'Cody', 'Colin', 'Colton', 'Connor', 'Conrad',
    'Corey', 'Cornelius', 'Cory', 'Courtney', 'Craig', 'Crystal', 'Curtis', 'Cynthia', 'Cyrus', 'Dale',
    'Dallas', 'Damian', 'Dana', 'Dane', 'Danielle', 'Danny', 'Daphne', 'Darlene', 'Darrell', 'Darren',
    'Dave', 'Dawn', 'Dean', 'Deanna', 'Debbie', 'Deborah', 'Debra', 'Denise', 'Dennis', 'Derek',
    'Derrick', 'Desmond', 'Devin', 'Diana', 'Diane', 'Diego', 'Dillon', 'Dominic', 'Don', 'Donald',
    'Donna', 'Donovan', 'Dorian', 'Dorothy', 'Doug', 'Douglas', 'Drake', 'Duane', 'Duncan', 'Dustin',
    'Dwayne', 'Dylan', 'Earl', 'Eddie', 'Edgar', 'Edmund', 'Eduardo', 'Edward', 'Edwin', 'Eileen',
    'Elaine', 'Eleanor', 'Elena', 'Eli', 'Elias', 'Ellen', 'Elliott', 'Ellis', 'Elmer', 'Eloise',
    'Elsa', 'Elsie', 'Emerson', 'Emilia', 'Emmanuel', 'Eric', 'Erica', 'Erik', 'Erin', 'Ernest',
    'Ethan', 'Eugene', 'Eva', 'Evan', 'Eve', 'Everly', 'Everett', 'Ezra', 'Faith', 'Faye',
    'Felix', 'Fernando', 'Finn', 'Fiona', 'Fletcher', 'Florence', 'Floyd', 'Frances', 'Francis', 'Francisco',
    'Frank', 'Franklin', 'Fred', 'Freddie', 'Frederick', 'Gabriel', 'Gabriella', 'Gail', 'Garrett', 'Gary',
    'Gavin', 'Gene', 'Geoffrey', 'George', 'Georgia', 'Gerald', 'Geraldine', 'Gerard', 'Gianna', 'Gilbert',
    'Gina', 'Giovanni', 'Glen', 'Glenn', 'Gloria', 'Gordon', 'Graham', 'Grant', 'Grayson', 'Greg',
    'Gregory', 'Gretchen', 'Griffin', 'Grover', 'Gus', 'Guy', 'Gwen', 'Gwendolyn', 'Hailey', 'Haley',
    'Harold', 'Harriet', 'Harrison', 'Harry', 'Harvey', 'Hayden', 'Hazel', 'Heath', 'Heather', 'Hector',
    'Heidi', 'Helen', 'Helena', 'Henry', 'Herbert', 'Herman', 'Hilda', 'Holly', 'Homer', 'Hope',
    'Horace', 'Howard', 'Hudson', 'Hugh', 'Hugo', 'Hunter', 'Ian', 'Ida', 'Ignacio', 'Igor',
    'Imogen', 'Ira', 'Irene', 'Iris', 'Irma', 'Irving', 'Isaac', 'Isabel', 'Isaiah', 'Ivan',
    'Ivy', 'Jack', 'Jackie', 'Jackson', 'Jacqueline', 'Jade', 'Jaden', 'Jake', 'Jana', 'Jane',
    'Janet', 'Janice', 'Jared', 'Jasmine', 'Jason', 'Jasper', 'Jay', 'Jean', 'Jeanette', 'Jeff',
    'Jeffrey', 'Jenna', 'Jennifer', 'Jenny', 'Jeremiah', 'Jeremy', 'Jerome', 'Jerry', 'Jesse', 'Jessica',
    'Jessie', 'Jill', 'Jim', 'Jimmy', 'Joan', 'Joanna', 'Jocelyn', 'Jodi', 'Jody', 'Joe',
    'Joel', 'Joey', 'Johanna', 'Jon', 'Jonathan', 'Jonathon', 'Josephine', 'Josh', 'Joyce', 'Juan',
    'Juanita', 'Judith', 'Judy', 'Julia', 'Julian', 'Julie', 'Juliet', 'Julius', 'June', 'Justin',
    'Kaitlyn', 'Karen', 'Karina', 'Karl', 'Karla', 'Kate', 'Katherine', 'Kathleen', 'Kathryn', 'Kathy',
    'Katie', 'Katrina', 'Kay', 'Kayla', 'Keith', 'Kelly', 'Kelsey', 'Ken', 'Kendall', 'Kennedy',
    'Kenneth', 'Kenny', 'Kent', 'Kerry', 'Kevin', 'Khloe', 'Kim', 'Kimberly', 'Kirk', 'Kristen',
    'Kristin', 'Kristina', 'Kurt', 'Kyle', 'Kylie', 'Lance', 'Landon', 'Larry', 'Laura', 'Lauren',
    'Laurence', 'Laurie', 'Lawrence', 'Layla', 'Leah', 'Lee', 'Leigh', 'Lena', 'Leo', 'Leon',
    'Leonard', 'Leonardo', 'Leroy', 'Leslie', 'Lester', 'Levi', 'Lewis', 'Lillian', 'Lily', 'Lincoln',
    'Linda', 'Lindsay', 'Lindsey', 'Lisa', 'Lloyd', 'Logan', 'Lois', 'Lola', 'Lonnie', 'Lorenzo',
    'Lori', 'Lorraine', 'Louis', 'Louise', 'Lowell', 'Lucia', 'Lucille', 'Lucy', 'Luis', 'Luke',
    'Luther', 'Lydia', 'Lynn', 'Mabel', 'Mackenzie', 'Madeline', 'Madison', 'Mae', 'Maggie', 'Malcolm',
    'Mallory', 'Manuel', 'Marc', 'Marcel', 'Marcia', 'Marcus', 'Margaret', 'Marge', 'Margie', 'Maria',
    'Marian', 'Marianne', 'Marie', 'Marilyn', 'Marina', 'Mario', 'Marion', 'Marissa', 'Marjorie', 'Mark',
    'Marlene', 'Marlon', 'Marshall', 'Martha', 'Martin', 'Marvin', 'Mary', 'Mason', 'Mathew', 'Matilda',
    'Matt', 'Maureen', 'Maurice', 'Max', 'Maxine', 'Maxwell', 'Maya', 'Megan', 'Melanie', 'Melinda',
    'Melissa', 'Melody', 'Melvin', 'Mercedes', 'Meredith', 'Micah', 'Michele', 'Michelle', 'Mickey', 'Miguel',
    'Mike', 'Mila', 'Mildred', 'Miles', 'Milton', 'Mindy', 'Miranda', 'Miriam', 'Mitchell', 'Molly',
    'Monica', 'Monte', 'Monty', 'Morris', 'Murray', 'Myra', 'Myrtle', 'Nancy', 'Naomi', 'Nathan',
    'Nathaniel', 'Neal', 'Neil', 'Nellie', 'Nelson', 'Nicholas', 'Nick', 'Nicolas', 'Nicole', 'Nina',
    'Noel', 'Nora', 'Norma', 'Norman', 'Nyla', 'Octavia', 'Odessa', 'Olga', 'Omar', 'Opal',
    'Orlando', 'Oscar', 'Otis', 'Otto', 'Owen', 'Pablo', 'Paige', 'Pamela', 'Paris', 'Patricia',
    'Patrick', 'Patsy', 'Patti', 'Patty', 'Paul', 'Paula', 'Pauline', 'Pearl', 'Pedro', 'Peggy',
    'Penelope', 'Penny', 'Percy', 'Perry', 'Pete', 'Peter', 'Philip', 'Phillip', 'Phoebe', 'Phyllis',
    'Pierre', 'Piper', 'Polly', 'Preston', 'Priscilla', 'Quentin', 'Quincy', 'Rachel', 'Rafael', 'Ralph',
    'Ramon', 'Ramona', 'Randall', 'Randy', 'Raul', 'Ray', 'Raymond', 'Rebecca', 'Regina', 'Reginald',
    'Rene', 'Renee', 'Rex', 'Rhonda', 'Ricardo', 'Richard', 'Rick', 'Ricky', 'Rita', 'Robert',
    'Roberta', 'Roberto', 'Robin', 'Robyn', 'Rocco', 'Rochelle', 'Rocky', 'Roderick', 'Rodney', 'Roger',
    'Roland', 'Roman', 'Ron', 'Ronald', 'Ronnie', 'Roosevelt', 'Rosa', 'Rosalie', 'Rose', 'Rosemary',
    'Rosie', 'Ross', 'Roxanne', 'Roy', 'Royce', 'Ruby', 'Rudolph', 'Rudy', 'Russell', 'Ruth',
    'Sabrina', 'Sadie', 'Sally', 'Salvador', 'Samantha', 'Samuel', 'Sandra', 'Sandy', 'Santiago', 'Sara',
    'Sarah', 'Sasha', 'Saul', 'Savannah', 'Sean', 'Sebastian', 'Selena', 'Serena', 'Seth', 'Shane',
    'Shannon', 'Sharon', 'Shaun', 'Shawn', 'Sheila', 'Shelby', 'Sheldon', 'Shelly', 'Sherman', 'Sherri',
    'Sherry', 'Shirley', 'Sidney', 'Sierra', 'Silas', 'Simon', 'Simone', 'Solomon', 'Sonia', 'Sonya',
    'Spencer', 'Stacey', 'Stacy', 'Stanley', 'Stella', 'Stephanie', 'Stephen', 'Sterling', 'Steve', 'Steven',
    'Stewart', 'Stuart', 'Sue', 'Summer', 'Susan', 'Suzanne', 'Sydney', 'Sylvia', 'Tabitha', 'Tamara',
    'Tammy', 'Tanner', 'Tanya', 'Tara', 'Ted', 'Teresa', 'Teri', 'Terrance', 'Terrence', 'Terri',
    'Terry', 'Tess', 'Tessa', 'Thaddeus', 'Thelma', 'Theodore', 'Theresa', 'Thomas', 'Tiffany', 'Tim',
    'Timothy', 'Tina', 'Toby', 'Todd', 'Tom', 'Tommy', 'Toni', 'Tony', 'Tonya', 'Tracey',
    'Tracy', 'Travis', 'Trevor', 'Trey', 'Tricia', 'Trinity', 'Tristan', 'Troy', 'Tucker', 'Tyler',
    'Tyrone', 'Tyson', 'Uma', 'Ursula', 'Valerie', 'Vanessa', 'Vaughn', 'Vera', 'Verna', 'Vernon',
    'Veronica', 'Vicki', 'Vicky', 'Victor', 'Vincent', 'Viola', 'Violet', 'Virgil', 'Virginia', 'Vivian',
    'Wade', 'Wallace', 'Walter', 'Wanda', 'Warren', 'Wayne', 'Wendell', 'Wendy', 'Wesley', 'Whitney',
    'Wilbur', 'Will', 'Willard', 'Willie', 'Willow', 'Wilma', 'Wilson', 'Winifred', 'Winston', 'Wolfgang',
    'Wyatt', 'Xavier', 'Yolanda', 'Yvette', 'Yvonne', 'Zachary', 'Zane', 'Zelda', 'Zoe'
  ]
  
  const JOCKEY_LAST_NAMES = [
    'Reed', 'Swift', 'Rider', 'Chase', 'Storm', 'Wright', 'Knight', 'Banks',
    'Rivers', 'Brooks', 'Fields', 'Lane', 'West', 'North', 'Woods', 'Wallace',
    'Strife', 'Kasaragi', 'Lockhart', 'Gainsborough', 'Fair', 'Gast', 'Biggs', 'Wedge',
    'Smith', 'Johnson', 'Williams', 'Brown', 'Jones', 'Garcia', 'Wallace', 'Davis',
    'Rodriguez', 'Martinez', 'Fernandes', 'Gonzalez', 'Sam', 'Anderson', 'Leggat',
    'Rackham', 'Mackay', 'Pincombe', 'White', 'Bell', 'Harding', 'Blair', 'Lawson',
    'Pearson', 'Dee', 'Davies', 'Othman', 'Abel', 'Togneri', 'Grey', 'Gray', 'Bruce',
    'Tyers', 'Delanay', 'Dugnut', 'Narasimmalu',
    // Final Fantasy-themed names
    'Leonhart', 'Highwind', 'Alexandros', 'Tribal', 'Branford', 'Crescent', 'Tuesti',
    'Shinra', 'Valentine', 'Kisaragi', 'Heartilly', 'Dincht', 'Trepe', 'Almasy', 'Kramer',
    'Loire', 'Caraway', 'Kinneas', 'Tilmitt', 'Bunansa', 'Beoulve', 'Heiral', 'Orlandeau',
    'Durai', 'Ronso', 'Guado', 'Lesca', 'Cid', 'Heidegger', 'Scarlet', 'Reeve', 'Tseng',
    'Reno', 'Rude', 'Elena', 'Rufus', 'Hojo', 'Lucrecia', 'Hollander', 'Lazard', 'Genesis',
    'Angeal', 'Sephiroth', 'Jenova', 'Minerva', 'Bahamut', 'Ifrit', 'Shiva', 'Ramuh',
    'Titan', 'Leviathan', 'Odin', 'Alexander', 'Phoenix', 'Carbuncle', 'Diablos', 'Fenrir',
    'Cerberus', 'Tonberry', 'Cactuar', 'Moogle', 'Chocobo', 'Malboro', 'Behemoth', 'Adamantoise',
    'Garland', 'Mateus', 'Xande', 'Zemus', 'Exdeath', 'Kefka', 'Ultimecia', 'Kuja',
    'Seymour', 'Vayne', 'Caius', 'Ardyn', 'Emet-Selch', 'Zenos', 'Lahabrea', 'Elidibus',
    'Farron', 'Villiers', 'Estheim', 'Rygdea', 'Nabaat', 'Katzroy', 'Paddra', 'Yun',
    'Fang', 'Vanille', 'Raines', 'Rosch', 'Primarch', 'Barthandelus', 'Orphan', 'Anima',
    'Valefor', 'Yojimbo', 'Magus', 'Belias', 'Mateus', 'Hashmal', 'Famfrit', 'Adrammelech',
    'Cuchulainn', 'Zalera', 'Zeromus', 'Exodus', 'Ultima', 'Zodiark', 'Chaos', 'Cosmos',
    'Warrior', 'Thief', 'Monk', 'Dragoon', 'Ninja', 'Samurai', 'Berserker', 'Ranger',
    'Mystic', 'Time-Mage', 'Summoner', 'Blue-Mage', 'Red-Mage', 'Black-Mage', 'White-Mage',
    'Sage', 'Onion', 'Freelancer', 'Mime', 'Gladiator', 'Pugilist', 'Marauder', 'Lancer',
    'Archer', 'Conjurer', 'Thaumaturge', 'Arcanist', 'Rogue', 'Machinist', 'Dark-Knight',
    'Astrologian', 'Scholar', 'Paladin', 'Bard', 'Dancer', 'Gunbreaker', 'Reaper', 'Viper',
    'Argentum', 'Izunia', 'Amicitia', 'Scientia', 'Altius', 'Fleuret', 'Aldercapt', 'Verstael',
    'Besithia', 'Tummelt', 'Loqi', 'Ravus', 'Aranea', 'Biggs', 'Jessie', 'Marlene',
    'Denzel', 'Kyrie', 'Leslie', 'Madam M', 'Andrea', 'Chocobo Sam', 'Scotch', 'Kotch',
    'Corneo', 'Heidegger', 'Scarlet', 'Palmer', 'Reeve', 'Cait Sith', 'Red XIII', 'Nanaki',
    'Bugenhagen', 'Cosmo', 'Canyon', 'Corel', 'Gongaga', 'Nibelheim', 'Rocket', 'Junon',
    'Costa', 'Gold Saucer', 'Temple', 'Icicle', 'Modeoheim', 'Banora', 'Kalm', 'Priscilla',
    'Shera', 'Lucrecia', 'Grimoire', 'Gillian', 'Claudia', 'Elmyra', 'Ifalna', 'Gast',
    'Faremis', 'Sonon', 'Melphie', 'Nayo', 'Billy', 'Polk', 'Yuffie', 'Godo', 'Staniv',
    'Shake', 'Chekhov', 'Gorki', 'Wutai', 'Midgar', 'Mideel', 'Bone Village', 'Forgotten City',
    'Promised Land', 'Lifestream', 'Meteor', 'Holy', 'Materia', 'Mako', 'Jenova', 'Weapon',
    'Sister Ray', 'Proud Clod', 'Diamond', 'Ruby', 'Emerald', 'Sapphire', 'Ultimate', 'Omega',
    'Bahamut ZERO', 'Knights', 'Turks', 'Avalanche', 'Deepground', 'Tsviets', 'Restrictor',
    'Weiss', 'Nero', 'Rosso', 'Azul', 'Shelke', 'Argento', 'Restrictors', 'Genesis',
    'Shalua', 'Yuffie', 'Vincent', 'Cid', 'Barret', 'Tifa', 'Cloud', 'Aerith', 'Sephiroth'
  ]
  
  export class JockeyFactory {
    static generateRandomJockey(targetRegion = null, targetWeight = null) {
      const firstName = JOCKEY_FIRST_NAMES[Math.floor(Math.random() * JOCKEY_FIRST_NAMES.length)];
      const lastName = JOCKEY_LAST_NAMES[Math.floor(Math.random() * JOCKEY_LAST_NAMES.length)];
      const name = `${firstName} ${lastName}`;
    
      // Define a list of all valid regions
      const allRegions = ['region1', 'region2', 'region3', 'region4', 'region5', 'region6'];
    
      // If a target region is provided, use it
      const region = targetRegion || allRegions[Math.floor(Math.random() * allRegions.length)];
    
      // If a target weight is provided, use it
      let weight;
      if (targetWeight) {
        weight = targetWeight;
      } else {
        weight = Math.floor(Math.random() * (75 - 45 + 1)) + 45; // Random weight between 45 and 75
      }
    
      const jockey = new Jockey(name, region);
      jockey.weight = weight;
    
      return jockey;
    }

    static generateInitialJockeys(count = 150) {
      const jockeys = [];
      const usedNames = new Set();
      const weightClasses = [
        { min: 45, max: 50 },
        { min: 51, max: 57 },
        { min: 58, max: 63 },
        { min: 64, max: 68 },
        { min: 69, max: 72 },
        { min: 73, max: 75 }
      ];
    
      for (let i = 0; i < count; i++) {
        const weightClass = weightClasses[i % weightClasses.length];
        let jockey = this.generateRandomJockey(null, (weightClass.min + weightClass.max) / 2);
    
        // Ensure unique names
        while (usedNames.has(jockey.name)) {
          jockey = this.generateRandomJockey(null, (weightClass.min + weightClass.max) / 2);
        }
    
        usedNames.add(jockey.name);
        jockeys.push(jockey);
      }
    
      return jockeys;
    }
    
    
    
  
    static filterJockeysByRegion(jockeys, preferredRegion) {
      if (!preferredRegion) return jockeys
      
      // Define neighboring regions
      const regionMapping = {
        'region1': ['region1', 'region2'],
        'region2': ['region1', 'region2'],
        'region3': ['region3', 'region4'],
        'region4': ['region3', 'region4'],
        'region5': ['region5'],
        'region6': ['region6']
      }
  
      const eligibleRegions = regionMapping[preferredRegion] || [preferredRegion]
      
      // Sort with local jockeys first, then others
      return [
        ...jockeys.filter(j => eligibleRegions.includes(j.region)),
        ...jockeys.filter(j => !eligibleRegions.includes(j.region))
      ]
    }
  }